import { render } from "./UsersTableWrapper.vue?vue&type=template&id=48f2f096&scoped=true"
import script from "./UsersTableWrapper.vue?vue&type=script&lang=js"
export * from "./UsersTableWrapper.vue?vue&type=script&lang=js"

import "./UsersTableWrapper.vue?vue&type=style&index=0&id=48f2f096&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f2f096"]])

export default __exports__